(function () {
  var selectors = {
    drawer: '[data-section-modification="drawer"][data-section-id]',
    cartItem: '[data-cart-item]',
    remove: '.js-cart-item-remove',
    quantity: '.js-quantity',
    quantityInput: '[data-quantity-input]',
    increase: '[data-quantity-increase]',
    decrease: '[data-quantity-decrease]',
    count: '[data-js-cart-count], .cart-count, [data-cart-count], .js-header-cart-item-count',
    error: '.js-cart-item-error-message'
  };

  var isUpdating = false;

  function init() {
    document.addEventListener('click', onCartActionClick, true);
  }

  function onCartActionClick(event) {
    var removeButton = event.target.closest(selectors.remove);
    var increaseButton = event.target.closest(selectors.increase);
    var decreaseButton = event.target.closest(selectors.decrease);
    var action = removeButton || increaseButton || decreaseButton;

    if (!action || !action.closest(selectors.drawer)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (isUpdating) return;

    if (removeButton) {
      var removeKey = removeButton.getAttribute('data-item-key');
      if (removeKey) {
        changeLine(removeKey, 0, removeButton);
      }
      return;
    }

    var quantity = getNextQuantity(action, !!increaseButton);
    if (!quantity || quantity.next === quantity.current) return;

    quantity.input.value = quantity.next;
    changeLine(quantity.itemKey, quantity.next, action, quantity.current);
  }

  function getNextQuantity(button, isIncrease) {
    var widget = button.closest(selectors.quantity);
    var input = widget && widget.querySelector(selectors.quantityInput);
    var itemKey = input && input.getAttribute('data-item-key');

    if (!input || !itemKey) return null;

    var current = parseInt(input.value, 10) || 0;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10);
    var max = parseInt(input.getAttribute('max'), 10);
    var next = isIncrease ? current + step : current - step;

    if (!Number.isNaN(min) && next < min) {
      next = min;
    }

    if (!Number.isNaN(max) && next > max) {
      next = max;
    }

    return {
      current: current,
      input: input,
      itemKey: itemKey,
      next: next
    };
  }

  async function changeLine(itemKey, quantity, sourceElement, previousQuantity) {
    setBusy(true);
    clearLineError(sourceElement);

    try {
      var cart = await postCartChange(itemKey, quantity);

      await refreshDrawer(cart.sections);
      updateCartCount(cart.item_count);
      emitCartUpdated(cart);
    } catch (error) {
      rollbackQuantity(sourceElement, previousQuantity);
      showLineError(sourceElement, error && (error.description || error.message));
      console.error('[CartRefresh] Cart update failed:', error);
    } finally {
      setBusy(false);
    }
  }

  async function postCartChange(itemKey, quantity) {
    var response = await fetch(getCartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    });

    var data = await response.json();

    if (!response.ok || data.status) {
      throw data;
    }

    return data;
  }

  async function refreshDrawer(sections) {
    var html = sections && sections['cart-drawer'];

    if (!html) {
      var response = await fetch(getSectionsUrl());
      var data = await response.json();
      html = data && data['cart-drawer'];
    }

    if (!html) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextDrawer = doc.querySelector(selectors.drawer);
    var currentDrawer = document.querySelector(selectors.drawer);

    if (!nextDrawer || !currentDrawer) return;

    currentDrawer.innerHTML = nextDrawer.innerHTML;
    currentDrawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));

    if (window.themeCore && window.themeCore.Accordion) {
      window.themeCore.Accordion.init();
    }

    if (window.themeCore && window.themeCore.Popover) {
      window.themeCore.Popover.init();
    }
  }

  function emitCartUpdated(cart) {
    if (!window.themeCore || !window.themeCore.EventBus || !cart) return;

    window.themeCore.cartObject = cart;
    window.themeCore.EventBus.emit('cart:updated', {
      ...cart,
      action: 'customCartChange',
      params: [{ noOpen: true }]
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll(selectors.count).forEach(function (element) {
      element.textContent = count > 99 ? '99+' : count;

      if (element.hasAttribute('data-cart-count')) {
        element.setAttribute('data-cart-count', count);
      }
    });
  }

  function getCartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';

    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function getSectionsUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-drawer');
    url.searchParams.set('lazyload', 'false');
    return url.toString();
  }

  function setBusy(isBusy) {
    var drawer = document.querySelector(selectors.drawer);

    isUpdating = isBusy;

    if (drawer) {
      drawer.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      drawer.classList.toggle('is-updating', isBusy);
    }
  }

  function clearLineError(sourceElement) {
    var error = getLineError(sourceElement);
    if (error) error.textContent = '';
  }

  function showLineError(sourceElement, message) {
    var error = getLineError(sourceElement);
    if (error) {
      error.textContent = message || 'Unable to update cart.';
    }
  }

  function getLineError(sourceElement) {
    var item = sourceElement && sourceElement.closest(selectors.cartItem);
    return item && item.querySelector(selectors.error);
  }

  function rollbackQuantity(sourceElement, previousQuantity) {
    if (typeof previousQuantity === 'undefined') return;

    var widget = sourceElement && sourceElement.closest(selectors.quantity);
    var input = widget && widget.querySelector(selectors.quantityInput);

    if (input) {
      input.value = previousQuantity;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
